import axiosIns from '@/plugins/axios'

export default {
  getIndividuallyConfirmableBusinessRuleAssignments() {
    return axiosIns.get('/v2/eod_closing/business_rule_assignments')
  },
  reorderBusinessRuleAssignments(orderedIds) {
    return axiosIns.patch('/v2/eod_closing/business_rule_assignments/reorder', {
      ordered_ids: orderedIds,
    })
  },
}
